module.exports = __webpack_public_path__ + "static/media/gray-arrow-icon.2df8ff63.svg";